const filterNodes = {
  quickShopModal: document.querySelector('quick-shop'),
  parent: document.getElementById('collectionFilters'),
  gridsContainer: document.getElementById('products-listing'),
  collectionBanner: document.querySelector('[data-collectionBanner]'),
  subCollectionLinks: Array.from(document.getElementsByClassName('subcollection-links')),
  openDrawerBtns: document.querySelectorAll('[data-openFilterDrawer]'),
  paginationParent: document.querySelector('[data-paginationParent]')
}

class CollectionFilters {
  constructor() {
    this.filterForm = filterNodes?.parent?.querySelector('form');

    filterNodes?.parent?.addEventListener('keyup', (event) => {
      if (event.code && event.code.toUpperCase() === 'ESCAPE'){ document.querySelectorAll('[data-closefilter]').forEach((e) => e.dispatchEvent(new Event('click')));}
    });

    this.debouncedOnSubmit = Utility.debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    if(this.filterForm){
      this.filterForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
      this.filterForm.addEventListener('submit', this.debouncedOnSubmit.bind(this));
      // window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }
    
    this.bindEvents();
    this.dynamicEleEvents();
    this.matchedProductsCount();
  }

  /**
   * bind dclick and keyup event to Cart Icons
   * bind keyUp event to Cart drawer component
   * bind Other inside element events
   *
  */
  bindEvents() {
    /** There are two open drawer buttons, one for Open filter drawer other for open sortby drawer **/
    if(filterNodes.openDrawerBtns.length > 0){
      filterNodes.openDrawerBtns.forEach(button => button.addEventListener('click', this.toggleFilterDrawer.bind(this)));
    }
    
    document.querySelectorAll('[data-closefilter]').forEach((e)=>{
      e?.addEventListener('click', this.toggleFilterDrawer.bind(this));
    })

    let sortby_desktop = document.querySelectorAll('[data-sortbymobile] .sortby_options');
    sortby_desktop.forEach(input => input.addEventListener('change', this.updateSortBy.bind(this)));

    let paginateByValues = document.querySelectorAll('[data-custom-pagination] [name="paginateBy"]');
    paginateByValues.forEach(input => input.addEventListener('change', this.paginateProductsBy.bind(this)));

    /** Only for horizontal filters - Close filters when clicked outside container **/
    const filterType = filterNodes?.parent?.dataset?.filtertype;
    if(filterType == 'horizontal-filters'){
      document.body.addEventListener('click', (_event)=>{
        const openFilters = document.querySelectorAll('.filter__container.open');
        openFilters.forEach((target) => {
          target.querySelector('.filter__toggle').click();
        })
      });
  
      const filterContainers = document.querySelectorAll('.filter__container');
      filterContainers.forEach((target) => {
        target.addEventListener('click', (event)=>{
          event.stopPropagation();
        });
      });
    }

    document.querySelectorAll('[data-back]').forEach((ele)=>{
      ele.addEventListener('click',(e)=>{
        e.preventDefault();
        e.target.closest('.filter__block')?.classList.remove('open')
      })
    })

    document.querySelectorAll('[data-filter-option]').forEach((ele)=>{
      ele.addEventListener('change',()=>{
        let count = 0
        document.querySelectorAll('[data-filter-option]').forEach((filterEle)=>{
          filterEle.checked ? count++ : 0
        })

        if (document.querySelector('[name="filter.v.price.gte"]')?.value != "" || document.querySelector('[name="filter.v.price.lte"]')?.value != "") {
          count++;
        }
        document.querySelectorAll('[data-active-count]').forEach((activeCountEle)=>{
          if (count > 0) {
            activeCountEle.innerHTML = ` (${count})`;
          }else{
            activeCountEle.innerHTML = ``;
          }
        })
      })
    })

    document.querySelector('#sort-drawer')?.addEventListener('click',(event)=>{
      event.preventDefault();
      event.stopImmediatePropagation();
      document.querySelector('.custom-dropdown.sortby-dropdown')?.classList.add('sort-active');
      siteOverlay.prototype.showOverlay();
    })
  }

  dynamicEleEvents() {
    /** Toggle each filter block container containing values for dropdown effect **/
    const toggleBtns = filterNodes?.parent?.getElementsByClassName('filter__toggle') ? Array.from(filterNodes?.parent?.getElementsByClassName('filter__toggle')) : [];
    toggleBtns.forEach(button => button.addEventListener('click', this.toggleFilterBlock.bind(this)));

    document.querySelector('body')?.addEventListener('click',(event)=>{
      // add class condition here
      if (document.body.classList.contains('vii-11-test')) {
        
      }else{
        if(!event.target?.closest('.csm-cookie-consent') && !event.target?.closest('[data-quick-view-trigger]')) {
          event.stopImmediatePropagation();
        }
        if(!event.target.closest('.filter__container') && !event.target.closest('#CollectionFiltersForm')){
          document.querySelectorAll('.filter__container').forEach((ele)=>{
            ele.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', false);
            Utility.toggleElement(ele, 'close');
          })
          document.querySelectorAll('custom-select.open .custom--select:not(:has([data-state-result-main]))').forEach((ele)=>{
            Utility.toggleElement(ele, 'close');
          })
        }
      }
    })
    
    filterNodes.subCollectionLinks = Array.from(document.getElementsByClassName('subcollection-links'));
    filterNodes.subCollectionLinks.forEach(link => link.addEventListener('click', this._manageSubCollections.bind(this)));

    if(filterNodes.quickShopModal && typeof filterNodes.quickShopModal.updateEvents == 'function'){ 
      filterNodes.quickShopModal.updateEvents(); 
    }

    const applyBtn = filterNodes?.parent?.querySelectorAll('[data-applyFilters]');
    if(applyBtn){
      applyBtn.forEach((e)=>{
        e.addEventListener('click', (event) => {
          event.preventDefault();
          this.filterForm.dispatchEvent(new Event('submit', {'bubbles' : true, 'cancelable' : true }));
        });
      })
    }

    const paginationLinks = document.querySelectorAll('[data-pagelinks]');
    paginationLinks.forEach(link => link.addEventListener('click', this._managePagination.bind(this)));

    this.bindActiveFilterButtonEvents();
  }

  /**
   * Collection filter form Input event
   * @param {event} event Event Instance
   */
  onSubmitHandler(event) {
    event.preventDefault();
    if(event.type == 'input' && filterNodes?.parent?.classList.contains('filter-active')){
      return;
    }

    const searchParams = this._createQueryString(this.filterForm)
    this.renderPage(searchParams);
  }

  /**
   * click event To Remove current selections
   * @param {element} form Collection page filter form
   */
  _createQueryString(form){
    // const formData = Array.from(new FormData(form)).filter(([k, v])=> { return v });
    const formData = new FormData(form);
    const priceGTE = form.querySelector('[name="filter.v.price.gte"]')?.min;
    const priceLTE = form.querySelector('[name="filter.v.price.lte"]')?.max;
    
    if(priceGTE && priceLTE){
    if(formData.get('filter.v.price.gte') == priceGTE){
      formData.delete('filter.v.price.gte');
      }if(formData.get('filter.v.price.lte') == priceLTE){
        formData.delete('filter.v.price.lte');
      }
    }

    return new URLSearchParams(Array.from(formData)).toString();
  }

  /**
   * 
   * @param {String} searchParams Query Parameters
   * @param {String} updateURLHash true/false
  */
  renderPage(searchParams, updateURLHash = true) {
    filterNodes.gridsContainer.classList.add('loading');

    const url = `${window.location.pathname}?${searchParams}`;
    this.renderGridFromFetch(url, 'filter');

    if (updateURLHash) this.updateURLHash(searchParams);
  }

  /**
   * click event To Remove current selections
   * @param {event} event Event Instance
   */
   onActiveFilterClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    let URLString = new URL(event.currentTarget.href).searchParams.toString();
    if(URLString != null) this.renderPage(URLString);
  }

   /**
   * Update Window URL as per active filters
   * @param {event} event Event Instance
   */
  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || '';
    this.renderPage(searchParams, false);
  }

  /**
   * 
   * @param {String} url URL for fetching results
   * @param {String} type filter / pagination / sub_collection
   */
  renderGridFromFetch(url, type) {
    if(!url) return;

    let sectionID = document.getElementById('products-listing')?.dataset?.id;
    if(type == 'sub_collection'){
      url += `&sections=${sectionID},template-collection-banner`;
    }else{
      url += `&sections=${sectionID}`;
    }
   
    fetch(url)
      .then(response => response.json())
      .then((response) => {
        let gridHTML = response[sectionID];
        let bannerHTML = response['template-collection-banner'];
        if (document.querySelector('#load-more') != null) {
          document.querySelector('#load-more').classList.remove('loading');
        }
        this.renderProductGrid(type, gridHTML, bannerHTML);
      });
  }

  /**
   * 
   * @param {HTMlResponse} html 
   * @param {String} type filter / pagination / sub_collection
   */
  renderProductGrid(type, grid, banner) {
    window.loadmorebutton=true;
    const openFilters = document.querySelectorAll('.filter__container.open');
    const collectionParent = new DOMParser().parseFromString(grid, 'text/html');
    
    // We have used individuals components replacement code because of load more feature
    let paginationType = 'numbers';
    if(filterNodes.paginationParent){
      paginationType = filterNodes.paginationParent?.dataset?.type || 'numbers';
    }

    if(type == 'pagination' && paginationType == 'loadmore'){
      let productGrids = filterNodes.gridsContainer.querySelector('#product-grids');
      productGrids.insertAdjacentHTML('beforeend', collectionParent.getElementById('product-grids').innerHTML);

      if (paginationType == 'loadmore') { 
        let loadMoreBtn = document.getElementById('load-more');
        let new_loadMoreBtn = collectionParent.getElementById('load-more');      
  
        if(new_loadMoreBtn && loadMoreBtn){   
          loadMoreBtn.parentNode.replaceChild(new_loadMoreBtn, loadMoreBtn); 
        }else if(loadMoreBtn){
          loadMoreBtn.remove();
        }
      }
    }else{
      const gridsHTML = collectionParent.getElementById('products-listing').innerHTML;
      filterNodes.gridsContainer.innerHTML = gridsHTML;
    }
    
    if (collectionParent.querySelector('[data-product-count]')?.getAttribute('data-product-count') == "0" ) {
      document.querySelector('custom-select.sortby-dropdown')?.classList.add('disabled','opacity-5');
    }else{
      document.querySelector('custom-select.sortby-dropdown')?.classList.remove('disabled','opacity-5');
    }

    const filterInnerHTML = collectionParent.getElementById('CollectionFiltersForm').innerHTML;
    this.filterForm.innerHTML = filterInnerHTML;

    const activeFilters = collectionParent.querySelector('[data-activeFilters]');
    if(activeFilters) document.querySelector('[data-activeFilters]').innerHTML = activeFilters.innerHTML;

    this.bindEvents();
    this.dynamicEleEvents();

    if (document.querySelector('[data-openfilterdrawer]')) {
      document.querySelector('[data-openfilterdrawer]').innerHTML = collectionParent.querySelector('[data-openfilterdrawer]').innerHTML
    }
    /******** Change banner on subcollection **********/
    if(type == 'sub_collection' && filterNodes.collectionBanner){
      const bannerNode = new DOMParser().parseFromString(banner, 'text/html');
      let bannerHTML = bannerNode.querySelector('[data-collectionBanner]').innerHTML;
      filterNodes.collectionBanner.innerHTML = bannerHTML;
    }

    /********  reopen filter blocks which are active before HTML update **********/
    openFilters.forEach(openFilter => {
      let filterBlock = document.querySelector('.filter__container[data-index="'+openFilter?.dataset?.index+'"]');
      filterBlock.classList.add('open');
      filterBlock.querySelector('.filter__block').classList.add('open');
    });

    /********  refresh yotpo review widget to display star rating **********/
    try{
      if (typeof yotpoWidgetsContainer !== 'undefined') {
        yotpoWidgetsContainer.initWidgets(false);
      }
    }catch(err){
      console.log(err,'<== Error')
    }
    // add class condition here
    if (document.body.classList.contains('vii-11-test')) {
    }
    else{
      document.querySelectorAll('[data-closefilter]').forEach(ele=>{
        ele?.dispatchEvent(new Event('click'));
      });
    }

    if(type != 'pagination'){
      if (!Utility.in_Viewport(document.querySelector('.breadcrumbs'))) {
        window.scrollTo({
          top: document.querySelector('.breadcrumbs')?.offsetTop - 100,
          behavior: "smooth" // Smooth scrolling behavior
        });
      }
    }
    
    this.matchedProductsCount();
    document.querySelectorAll('img[data-srcset]').forEach(el => {
      el.setAttribute('srcset', el.getAttribute('data-srcset'));
    });
    
    // Dispatch event for subscription toggle to re-apply state
    document.dispatchEvent(new CustomEvent('collectionContentUpdated', {
      detail: { type: type }
    }));
  }

  /**
   * Re-Binding events on active filters after ajax request
   */
  bindActiveFilterButtonEvents() {
    let removeActiveFilters = Array.from(document.querySelectorAll('[data-reset-filters]'));
    removeActiveFilters.forEach((element) => {
      element.addEventListener('click', this.onActiveFilterClick.bind(this), { once: true });
    });
  }

  /**
   * Handle clicks on [data-all-filter] elements
   * @param {event} event Event Instance
   */
  onAllFilterClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    // Check if the element has 'active' class (selected state)
    if (event.target?.closest('li')?.classList.contains('active')) {
      // If active, don't allow clicking - element should not be clickable
      return;
    }
    event.target?.closest('li')?.classList.add('active');

    // Find the first [data-reset-filters] element and trigger its click event
    const resetFilterElement = document.querySelector('[data-activefilters] [data-reset-filters]');
    if (resetFilterElement) {
      resetFilterElement.click();
    }
  }

  /**
   * Update the url
   * @param {String} searchParams 
   */
  updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  /**
   * 
   * @param {event} event 
   */
  updateSortBy(event){
    let currentEle = event.currentTarget;
    let targetOpt = document.querySelector(`input[name="custom_sort_by"][value="${currentEle?.value}"]`);
    document.querySelector('[name="sort_by"]') && (document.querySelector('[name="sort_by"]').value=currentEle?.value);
    if(targetOpt){
      targetOpt.checked = true;
      document.dispatchEvent(new Event('input', {
        once: true,
      }));
    }
    this.filterForm.dispatchEvent(new Event('submit'))
  }

  /**
   * 
   * @param {event} event 
   */
  paginateProductsBy(event){
    event.preventDefault();
    let currentValue = document.querySelector('[data-custom-pagination] [name="paginateBy"]:checked').value;
    let requestData = { 
      attributes: { 'products_per_page': currentValue } 
    };

    fetch("/cart/update", {
    method: "POST",
    headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
    },
    body: JSON.stringify(requestData),
    }).then((data) =>{
      const searchParams = this._createQueryString(this.filterForm);
      const url = `${window.location.pathname}?${searchParams}`;
      this.renderGridFromFetch(url, 'pagination');
    });
  }

  /**
   * 
   * @param {event} event 
   */
  _manageSubCollections(event){
    event.preventDefault();
    const _this =  event.currentTarget;
    const queryString = this._createQueryString(this.filterForm);
    let collURL = _this.href + '?' + queryString;
  
    this.renderGridFromFetch(collURL, 'sub_collection');

    setTimeout(() => {
      filterNodes.subCollectionLinks.forEach(link => link.classList.remove('active'));
      _this.classList.add('active');
      history.pushState({}, '', collURL);
    }, 500);
  }

  /**
   * 
   * @param {event} event 
   */
  _managePagination(event){
    event.preventDefault();
    let _this = event.currentTarget;
    var nextPageLink = _this.href;
    this.renderGridFromFetch(nextPageLink, 'pagination');

    let paginationType = _this.closest('[data-paginationparent]')?.dataset?.type;
    if(paginationType != 'loadmore'){
      setTimeout(() => {
        history.pushState({}, '', nextPageLink);
      }, 500);
    }else{
      if (document.querySelector('#load-more') != null) {
        document.querySelector('#load-more').classList.add('loading');
      }
    }
  }

  /**
   * Toggle Filter drawer
   * @param {event} event 
   */
  toggleFilterDrawer(event){
    event.preventDefault();
    let button = event.currentTarget;
    if(button.id == 'filter-drawer'){
      button.setAttribute('aria-expanded', true);
      button.setAttribute('tabindex', '-1');

      filterNodes?.parent?.classList.add('filter-active');

      Utility.trapFocus(filterNodes?.parent);
      Utility.forceFocus(filterNodes?.parent?.querySelector('[data-closeFilter]'));
      
      document.querySelector('body').classList.add('scroll-fixed');
      document.body.style.overflowY = "hidden";
    }else{
      filterNodes?.parent?.classList.remove('filter-active');
      if(this.openFilterDrawer){
        this.openFilterDrawer.setAttribute('aria-expanded', false);
        this.openFilterDrawer.removeAttribute('tabindex');
      }
      if(this.openSortbyDrawer){
        this.openSortbyDrawer.setAttribute('aria-expanded', false);
        this.openSortbyDrawer.removeAttribute('tabindex');
      }

      Utility.removeTrapFocus(filterNodes?.parent);
      setTimeout(() => {
        document.querySelector('body').classList.remove('scroll-fixed');
        document.body.style.overflowY = "auto";
      }, 550);

      document.querySelectorAll('[data-filtertype] .filter__container').forEach((ele)=>{
        if (!ele.querySelector('price-range')) {
          ele.classList.remove('open');
        }
      })
      this._closeSortByDrawer();
    }
  }

  _closeSortByDrawer(){
    document.querySelector('custom-select.sort-active')?.classList.remove('sort-active');
    siteOverlay.prototype.hideOverlay();
  }
  /**
   * Toggle Filter drawer
   * @param {event} event 
  */
  toggleFilterBlock(event) {
    event.preventDefault();
    const toggleFilterBtn = event.currentTarget;
    const filterContainer = toggleFilterBtn.closest('.filter__container');
    const isOpen = filterContainer.classList.contains('open');
    isOpen ? this.closeFilterBlock(toggleFilterBtn) : this.openFilterBlock(toggleFilterBtn);
  }

  /**
   * Open Filter Block
   * @param {element} toggleFilterBtn 
   */
  openFilterBlock(toggleFilterBtn){
    let filterContainer = toggleFilterBtn.closest('.filter__container');
    toggleFilterBtn.setAttribute('aria-expanded', true);
    // add class condition here
    if (document.body.classList.contains('vii-11-test')) {
    }
    else{
      document.querySelectorAll('.filter__container').forEach((ele)=>{
        ele.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', false);
        Utility.toggleElement(ele, 'close');
      })
    }
    Utility.toggleElement(filterContainer, 'open');
    Utility.trapFocus(filterContainer);
  }


  /**
   * Close Filter Block
   * @param {element} toggleFilterBtn 
   */
  closeFilterBlock(toggleFilterBtn){
    const filterContainer = toggleFilterBtn.closest('.filter__container');
    toggleFilterBtn.setAttribute('aria-expanded', false);
    Utility.toggleElement(filterContainer, 'close');
    Utility.removeTrapFocus(filterContainer);
  }

  matchedProductsCount = () => {
    document.querySelectorAll('[data-scroll-to]').forEach((ele)=>{
      let id = ele.getAttribute('data-scroll-to');
      let matchedSection = document.querySelector(`[data-scroll-call="${id}"]`);
      if (matchedSection) {
        ele?.classList.remove('d-none')
      }else{
        ele?.classList.add('d-none')
      }
    })
  }
}
typeof CollectionFilters !== 'undefined' && new CollectionFilters();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  /**
   * 
   * @param {event} event 
   */
  onRangeChange(event) {
    setTimeout(() => {
      this.adjustToValidValues(event.currentTarget);
      this.setMinAndMaxValues();
    }, 500);
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput) {
      if (maxInput.value) minInput.setAttribute('max', maxInput.value);
      if (minInput.value) maxInput.setAttribute('min', minInput.value);
      if (minInput.value === '') maxInput.setAttribute('min', 0);
      if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
    }
  }

  adjustToValidValues(input) {
    if (input) {
      const value = Number(input.value);
      const min = Number(input.getAttribute('min'));
      const max = Number(input.getAttribute('max'));
  
      if (value < min) input.value = min;
      if (value > max) input.value = max;
    }
  }

}
customElements.define('price-range', PriceRange);

class PriceRangeSlider extends HTMLElement {
  constructor() {
    super();

    let _this = this;
    let sliderSections = this?.getElementsByClassName("range-slider");
    
    for(const element of sliderSections){
      let sliders = element.getElementsByTagName("input");
      for(const element of sliders){
        if(element.type ==="range" ){
          element.oninput = _this.getVals;
          element.oninput();
        }
      }
    }
  }
  
  // Get Price value from both range slider
  getVals(){
    let parent = this.parentNode;
    let slides = parent.getElementsByTagName("input");
    if (slides && slides.length) {
      let slide1 = parseFloat(slides[0].value);
      let slide2 = parseFloat(slides[1].value);
        
      // Neither slider will clip the other, so make sure we determine which is larger
      if( slide1 > slide2 ){ let tmp = slide2; slide2 = slide1; slide1 = tmp; }
      
      let displayElement = parent?.getElementsByClassName("rangeValues")[0];
      if (displayElement) {
        displayElement.innerHTML = Utility.formatMoney((slide1*100), window.globalVariables.money_format)+ ' - ' + Utility.formatMoney((slide2*100), window.globalVariables.money_format);
      }
    }
  }
}
customElements.define('range-slider', PriceRangeSlider);

class FilterBlocks extends HTMLElement {
  constructor() {
    super();
    this.filterBlocks = this.querySelectorAll('filter-blocks input');
    this.allFilter = this.querySelector('[data-product-filter="all"]');
    this.availableFilters = this.querySelectorAll('[data-product-filter]:not([data-product-filter="all"])');
    this.activeFiltersElement = this.querySelector('[data-activeFilters]');
    this.productGrids = document.querySelectorAll('#products-listing [data-product-grid]'); 
    this.activeFilters = [];
  }

  connectedCallback() {
    this.filterBlocks.forEach(block => {
      block.addEventListener('change', this.onFilterChange.bind(this));
    });

    this.manageUniqueFilters();
  }

  onFilterChange(event) {
    this.activeFilters = [];
    this.productGrids = document.querySelectorAll('#products-listing [data-product-grid]'); 
    const allActiveFilters = Array.from(this.querySelectorAll('[data-product-filter]:has(input:checked)')).map(filter => filter.getAttribute('data-product-filter'));
    
    // Remove active class from all filter items first
    this.querySelectorAll('[data-product-filter]').forEach(filter => {
      filter.classList.remove('active');
    });
    
    // Add active class to the currently checked item
    this.querySelectorAll('[data-product-filter]').forEach(filter => {
      filter.querySelector('input').checked ? filter.closest('li').classList.add('active') : filter.closest('li').classList.remove('active');
    });
    
    if (event.target.value.toLowerCase() == 'all' || allActiveFilters.length == 0) {
      this.productGrids.forEach(grid => {
        grid.classList.remove('d-none');
        grid.closest('.card-product-parent').classList.remove('d-none');
      });
      this.availableFilters.forEach(filter => {
        filter.querySelector('input').checked = false;
        filter.classList.remove('active');
      });
      if (this.allFilter) {
        this.allFilter.classList.add('active');
        this.allFilter.querySelector('input').checked = true;
      }
      this.activeFilters = Array.from(this.querySelectorAll('[data-product-filter]:has(input:checked)')).map(filter => filter.getAttribute('data-product-filter'));
      this._manageActiveFilters();
      return;
    }
    if (this.allFilter) {
      this.allFilter.classList.remove('active');
      this.allFilter.querySelector('input').checked = false;
    }
    this.productGrids.forEach(grid => {
      const filters = grid.dataset.appliableFilters.split(',');
      const isActive = filters.some(filter => allActiveFilters.includes(filter));
      grid.classList.toggle('d-none', !isActive);
      grid.closest('.card-product-parent').classList.toggle('d-none', !isActive);
    });
    this.activeFilters = Array.from(this.querySelectorAll('[data-product-filter]:has(input:checked)')).map(filter => filter.getAttribute('data-product-filter'));
    this._manageActiveFilters();
  }

  _manageActiveFilters(){
    let tempHtml = '<a href="#" data-reset-filter="all" class="filter-option-clear d-inline-flex lh-1 rounded-3 text-capitalize bg-primary-400 text-white clear-all fs-md">Clear all<i class="icon-close my-auto"></i></a>';
    this.activeFilters.forEach(filter => {
      tempHtml = tempHtml + `<a data-reset-filter="${filter}" class="filter-option-clear filter-option d-inline-flex lh-1 rounded-3 text-capitalize bg-primary-200 fs-md" href="#">
        ${filter}<i class="icon-close my-auto"></i>
      </a>`;
    });
    // this.activeFiltersElement.innerHTML = tempHtml;
    
    // if (this.activeFilters.length) {
    //   this.activeFiltersElement.classList.remove('d-none');
    //   if (this.activeFilters.length == 1 && this.activeFilters[0] == 'all') {
    //     this.activeFiltersElement.classList.add('d-none');
    //   }
    // }else{
    //   this.activeFiltersElement.classList.add('d-none');
    // }
    this.bindResetFilter();
  }

  bindResetFilter(){
    this.activeFiltersElement.querySelectorAll('[data-reset-filter]').forEach(filter => {
      filter.addEventListener('click', this.onResetFilter.bind(this));
    });
  }

  onResetFilter(event){
    event.preventDefault();
    event.stopImmediatePropagation();
    const filter = event.currentTarget.getAttribute('data-reset-filter');
    this.querySelector(`[data-product-filter="${filter}"] input`).checked = false;
    this.querySelector(`[data-product-filter="${filter}"] input`).dispatchEvent(new Event('change'));
  }

  manageUniqueFilters(){
    if (!this.productGrids) {
      return;
    }
    const uniqueFilters = Array.from(this.productGrids).map(filter => filter.getAttribute('data-appliable-filters').split(','));
    const uniqueFiltersSet = [...new Set(uniqueFilters.flat())].filter(Boolean);
    this.availableFilters.forEach(filter => {
      filter.classList.add('d-none');
    });
    uniqueFiltersSet.forEach(filter => {
      const filterBlock = this.querySelector(`[data-product-filter="${filter.toLowerCase()}"]`);
      if (filterBlock) {
        filterBlock.classList.remove('d-none');
      }
    });
  }
}
customElements.define('filter-blocks', FilterBlocks);
